import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Caricamento...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Controlla se l'utente ha il ruolo ADMIN (controllo flessibile)
  const hasAdminRole = user?.ruoli?.some(role => 
    role?.toUpperCase() === 'ADMIN' || 
    role?.toUpperCase() === 'ADMINISTRATOR' ||
    role?.toLowerCase() === 'admin'
  ) || false;
  
  // Debug temporaneo
  console.log('AdminRoute - User roles:', user?.ruoli);
  console.log('AdminRoute - Has admin role:', hasAdminRole);

  if (!hasAdminRole) {
    return (
      <div className="access-denied">
        <h2>Accesso Negato</h2>
        <p>Non hai i permessi necessari per accedere a questa sezione.</p>
        <p>Solo gli amministratori possono accedere alla gestione utenti.</p>
        <button onClick={() => window.history.back()}>
          Torna Indietro
        </button>
      </div>
    );
  }

  return <>{children}</>;
};

export default AdminRoute;